import { whitelistedLeadSources, } from 'hx-analytics/src/constants/url-lead-source.constant';
export function isSupportedLeadSource(source) {
    return whitelistedLeadSources.includes(source);
}
